export default __webpack_public_path__ + "static/media/copenhagen-silhouette.cd223095.jpg";